import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AuthService } from 'src/app/auth/auth.service';

import { MENUS } from 'src/app/constants/menu.constant';
import { environment } from 'src/environments/environment';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight, faUser } from '@fortawesome/free-solid-svg-icons';
import { IMenu } from 'src/app/models/menu.model';
import { MenuBadgeService } from 'src/app/modules/finance-work/services/menu-badge.service';
import { Subscription, interval } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-main-theme',
    templateUrl: './main-theme.component.html',
    styleUrls: ['./main-theme.component.scss'],
})
export class MainThemeComponent implements OnInit, OnDestroy {
    constructor(
        private router: Router,
        private auth: AuthService,
        private menuBadgeService: MenuBadgeService
    ) {}

    appVersion: string | null = environment.appVersion;
    isCollapseSidebar: boolean = false;
    currentFirstName: string = '';
    icons = {
        faChevronRight: faChevronRight as IconProp,
        faUser: faUser as IconProp,
    };

    menus = MENUS;
    menusCollapse: { [id: string]: boolean } = {};

    // ---- ตัวเลขงานค้างข้างเมนู (วงกลมแดง — user เคาะ 9 ก.ย. 2569) ----
    /** key = ท้าย path ของเมนู เช่น '/finance-work/passport-check' → 'passport-check' */
    badges: { [menuKey: string]: number | null } = {};
    private badgeSubs = new Subscription();
    /** ตาข่ายกันเลขค้าง — ปกติเลขอัปเดตทันทีจาก interceptor ตอนมีคำสั่งเขียนสำเร็จอยู่แล้ว */
    private readonly BADGE_REFRESH_MS = 180000;

    badgeOf(menu: IMenu): number | null {
        const key = (menu.link || '').split('/').pop() || '';
        const n = this.badges[key];
        return typeof n === 'number' && n > 0 ? n : null;
    }
    /** ผลรวมของเมนูย่อย — โชว์ที่หัวข้อเวลาเมนูพับอยู่ */
    badgeOfGroup(menu: IMenu): number | null {
        if (!menu.subMenu) return null;
        const sum = menu.subMenu.reduce((t, s) => t + (s.isHidden ? 0 : this.badgeOf(s) ?? 0), 0);
        return sum > 0 ? sum : null;
    }
    badgeText(n: number): string {
        return n > 99 ? '99+' : String(n);
    }
    ngOnDestroy(): void {
        this.badgeSubs.unsubscribe();
    }

    ngOnInit(): void {
        // ตัวเลขมาจากที่เดียว (MenuBadgeService) — ทุกที่สั่ง refresh ได้ หน้านี้แค่แสดงผล
        this.badgeSubs.add(this.menuBadgeService.counts$.subscribe((c) => (this.badges = c)));
        this.menuBadgeService.refresh();
        // เปลี่ยนเมนู = นับใหม่ (ผู้ใช้คาดหวังว่ากดเมนูอื่นแล้วเลขตรง — user แจ้ง 15 ก.ย. 2569)
        this.badgeSubs.add(
            this.router.events
                .pipe(filter((e) => e instanceof NavigationEnd))
                .subscribe(() => this.menuBadgeService.refresh())
        );
        this.badgeSubs.add(interval(this.BADGE_REFRESH_MS).subscribe(() => this.menuBadgeService.refresh()));

        this.currentFirstName = this.auth.getCurrentAgencyMember()?.first_name || '';
        this.initMenu();
    }

    private initMenu(): void {
        const userRole = this.auth.getCurrentRole();
        this.menus.forEach((menu) => {
            // Display menu show/hide follow access role.
            menu.isHidden = !this.checkAccessByRole(userRole, menu.accessRoles);
            menu.subMenu?.forEach((submenu) => {
                submenu.isHidden = !this.checkAccessByRole(userRole!, submenu.accessRoles);
            });

            // Adjust submenu menu toggle.
            if (menu.subMenu && menu.subMenu.length > 0) {
                this.menusCollapse[menu.slug!] = true;
            }
        });
    }

    private checkAccessByRole(agencyRole: string | null, pageRoles?: string[]): boolean {
        if (pageRoles === undefined) {
            // Pages is not want any role to access.
            return true;
        }

        if (agencyRole === null) {
            // This not authen
            return false;
        }

        return pageRoles.indexOf(agencyRole) >= 0;
    }

    onSubMenuClickToNavigation(menu: IMenu): void {
        if (menu?.slug === 'pre-product-file-reports') {
            this.auth.vibecodeToken().subscribe((vibecodeToken) => {
                if (vibecodeToken) {
                    const preProductFileReportsUrl = new URL(`auth?${new URLSearchParams({ token: vibecodeToken })}`, environment.vibeCodeUrl).toString();
                    window.open(preProductFileReportsUrl, '_blank');
                }
            });
        } else {
            this.router.navigate([menu.link]);
        }
    }
    
}
